import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type Lang = 'en' | 'es';

interface LangState {
  lang: Lang;
  setLang: (l: Lang) => void;
  /**
   * D-07 (2026-08-21) — de qué EA vino la última siembra automática de idioma.
   *
   * La regla Ronda 2 R2 dice que el guion arranca en el idioma del miembro, y
   * D-07 dice que después manda el botón de la barra. Las dos son ciertas, y se
   * contradecían en un punto que nadie había escrito: **al RE-ENTRAR a la misma
   * EA**. La marca de «ya sembré» vivía en un `useRef` del componente, o sea
   * one-shot por MONTAJE — y salir al caso y volver es el flujo normal, no un
   * caso raro. Medido por la revisión adversarial de D-07: el navigator elegía
   * español a mitad de la llamada, salía a registrar algo, volvía, y la ficha le
   * pisaba la elección **en silencio**. Justo el escenario que D-07 nombra.
   *
   * Con la marca acá —persistida, y por EA— la regla queda dicha: **se siembra
   * UNA vez por evaluación; dentro de esa evaluación manda el navigator**. Abrir
   * la EA de otro miembro vuelve a sembrar, que es lo que R2 protege.
   */
  seededForEa: string | null;
  markLangSeeded: (eaId: string) => void;
}

export const useLanguageStore = create<LangState>()(
  persist(
    (set) => ({
      lang: 'en',
      setLang: (l) => set({ lang: l }),
      seededForEa: null,
      markLangSeeded: (eaId) => set({ seededForEa: eaId }),
    }),
    {
      name: 'pathway.lang',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
